import React from "react";

function privacy() {
  return (
    <div className="flex w-full items-center justify-center px-5">
      <div className="max-w-md md:max-w-xl ">
        <div className="text-3xl text-start my-4 font-bold">Privacy Policy</div>
        <div className="text-gray-700 mb-2">
          Welcome to Collats (“Company”, “we”, “our”, “us”)!
        </div>
        <div className="text-gray-700 mb-2">
          This Privacy Policy shall be read in conjunction and together with the
          our Terms and Conditions and our Disclaimers
        </div>
        <div className="text-gray-700 mb-2">
          By using the Collats website, mobile application (the “App”), and
          services (collectively, the Service), you consent to the following
          privacy policy.
        </div>
        <div className="text-gray-700 mb-2">
          Collats built the Service as a Free app. This Service is provided by
          Collats at no cost and is intended for use as is.
        </div>
        <div className="text-gray-700 mb-2">
          This page is used to inform visitors regarding our policies with the
          collection, use, and disclosure of Personal Information if anyone
          decided to use our Service.
        </div>
        <div className="text-gray-700 mb-2">
          Personal data is information about you that can identify you, such as
          your name, email address and other information that is not otherwise
          publicly available.
        </div>
        <div className="text-gray-700 mb-2">
          If you choose to use our Service, then you agree to the collection and
          use of information in relation to this policy. The Personal
          Information that we collect is used for providing and improving the
          Service. We will not use or share your information with anyone except
          as described in this Privacy Policy.
        </div>
        <div className="text-gray-700 mb-2">
          The terms used in this Privacy Policy have the same meanings as in our
          Terms and Conditions, which are accessible at Collats unless otherwise
          defined in this Privacy Policy.
        </div>
        <div>
          <div className="text-lg my-4 font-bold">
            Information Collection and Use
          </div>
        </div>
        <div className="text-gray-700 mb-2">
          For a better experience, while using our Service, we may require you
          to provide us with certain personally identifiable information,
          including but not limited to Wallet Address, IP Address, Blockchain
          Transactions. The information that we request will be retained on your
          device and is not collected by us in any way.
        </div>
        <div className="text-gray-700 mb-2">
          The Service does use third-party services that may collect information
          used to identify you.
        </div>
        <div className="text-gray-700 mb-2">
          Link to the privacy policy of third-party service providers used by
          the app
        </div>
        <ul>
          <li>
            <a
              href="https://www.google.com/policies/privacy/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Google Play Services
            </a>
          </li>
          <li>
            <a
              href="https://firebase.google.com/policies/analytics"
              target="_blank"
              rel="noopener noreferrer"
            >
              Google Analytics for Firebase
            </a>
          </li>
          <li>
            <a
              href="https://firebase.google.com/support/privacy/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Firebase Crashlytics
            </a>
          </li>
          <li>
            <a
              href="https://www.facebook.com/about/privacy/update/printable"
              target="_blank"
              rel="noopener noreferrer"
            >
              Facebook
            </a>
          </li>
          <li>
            <a
              href="https://moralis.io/privacy-policy/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Moralis
            </a>
          </li>
        </ul>
        <div className="text-lg my-4 font-bold">Google Analytics</div>
        <div className="text-gray-700 mb-2">
          We use Google Analytics which is a web analysis service that collects
          and analyses the data about the behavior of the Site visitors. Among
          other things, it collects data on which you have come to the Site from
          (so-called referrers), which sub-pages of the Site were accessed and
          how often and which period of time a sub-page was viewed. A web
          analysis is mainly used to optimize the Site and for the cost-benefit
          analysis of Internet advertising.
        </div>
        <div className="text-gray-700 mb-2">
          Google Analytics uses technical tool called cookie. The information
          generated by the cookie about your use of this website is usually
          transmitted to a Google server in the USA and stored there. Google
          might transfer the personal information collected via this technical
          procedure to third parties.
        </div>
        <div className="text-gray-700 mb-2">
          You can prevent the storage of cookies by a corresponding setting of
          your browser software or by choosing appropriate menu in the Cookies
          pop-up at bottom of the Site. However, please note that if you do
          this, you may not be able to use all the features of this website to
          the fullest extent possible. In addition, all cookies already set can
          be deleted at any time via the Internet browser or other software
          programs.
        </div>
        <div className="text-gray-700 mb-2">
          More details on how Google Analytics works can be found at:
          https://policies.google.com/technologies/partner-sites
        </div>
        <div className="text-lg my-4 font-bold">Log Data</div>
        <div className="text-gray-700 mb-2">
          We want to inform you that whenever you use the Service, in a case of
          an error in the app we collect data and information (through
          third-party products) on your device called Log Data. This Log Data
          may include information such as your device Internet Protocol (“IP”)
          address, device name, operating system version, the configuration of
          the app when utilizing the Service, the time and date of your use of
          the Service, and other statistics.
        </div>
        <div className="text-lg my-4 font-bold">Cookies</div>
        <div className="text-gray-700 mb-2">
          Cookies are files with a small amount of data that are commonly used
          as anonymous unique identifiers. These are sent to your browser from
          the websites that you visit and are stored on your device&apos;s
          internal memory.
        </div>
        <div className="text-gray-700 mb-2">
          This Service does not use these “cookies” explicitly. However, the app
          may use third-party code and libraries that use “cookies” to collect
          information and improve their services. You have the option to either
          accept or refuse these cookies and know when a cookie is being sent to
          your device. If you choose to refuse our cookies, you may not be able
          to use some portions of the Service.
        </div>
        <div className="text-lg my-4 font-bold">Service Providers</div>
        <div className="text-gray-700 mb-2">
          We may employ third-party companies and individuals due to the
          following reasons:
        </div>
        <ul>
          <li>To facilitate our Service;</li>{" "}
          <li>To provide the Service on our behalf;</li>{" "}
          <li>To perform Service-related services; or</li>{" "}
          <li>To assist us in analyzing how our Service is used.</li>
        </ul>{" "}
        <div className="text-gray-700 mb-2">
          We want to inform users of the Service that these third parties have
          access to their Personal Information. The reason is to perform the
          tasks assigned to them on our behalf. However, they are obligated not
          to disclose or use the information for any other purpose.
        </div>
        <div className="text-lg my-4 font-bold">Security</div>
        <div className="text-gray-700 mb-2">
          We value your trust in providing us your Personal Information, thus we
          are striving to use commercially acceptable means of protecting it.
          But remember that no method of transmission over the internet, or
          method of electronic storage is 100% secure and reliable, and we
          cannot guarantee its absolute security.
        </div>
        <div className="text-lg my-4 font-bold">Blockchain</div>
        <div className="text-gray-700 mb-2">
          Note that the Services employ Smart Contracts that collect information
          that is then stored on a Block Chain that we do not control. If you
          use the Services, you are consenting to allow your information to be
          cryptographically transmitted and stored on that blockchain, and any
          deletion or modification of that information (to the extent possible
          on a blockchain) is governed by the terms of the relevant Smart
          Contract.
        </div>
        <div className="text-gray-700 mb-2">
          The Service is intended to broadcast your transactions into
          blockchains for permanent storage and once it is done that data cannot
          be changed or deleted. Be mindful with your transaction and do not
          incorporate into them any data you are not willing to make publicly
          and permanently available.
        </div>
        <div className="text-gray-700 mb-2">
          The service uses information taken directly from the blockchain
          network through which transactions were carried out.
        </div>
        <div className="text-lg my-4 font-bold">Links to Other Sites</div>
        <div className="text-gray-700 mb-2">
          The Service may contain links to other sites. If you click on a
          third-party link, you will be directed to that site. Note that these
          external sites are not operated by us. Therefore, we strongly advise
          you to review the Privacy Policy of these websites. We have no control
          over and assume no responsibility for the content, privacy policies,
          or practices of any third-party sites or services.
        </div>
        <div className="text-lg my-4 font-bold">Children’s Privacy</div>
        <div className="text-gray-700 mb-2">
          These Services do not address anyone under the age of 13. We do not
          knowingly collect personally identifiable information from children
          under 13 years of age. In the case we discover that a child under 13
          has provided us with personal information, we immediately delete this
          from our servers. If you are a parent or guardian and you are aware
          that your child has provided us with personal information, please
          contact us so that we will be able to do the necessary actions.
        </div>
        <div className="text-lg my-4 font-bold">
          Changes to This Privacy Policy
        </div>
        <div className="text-gray-700 mb-2">
          We may update our Privacy Policy from time to time. Thus, you are
          advised to review this page periodically for any changes. We will
          notify you of any changes by posting the new Privacy Policy on this
          page.
        </div>
        <div>This policy is effective as of 2022-07-18</div>
        <div className="text-lg my-4 font-bold">Contact Us</div>
        <div className="text-gray-700 mb-2">
          If you have any questions or suggestions about our Privacy Policy, do
          not hesitate to contact us at admin@collats.com.
        </div>
      </div>
    </div>
  );
}

export default privacy;
